import { Checkmark } from '@remarkable/ark-icons';
import { Tag, Typography } from '@remarkable/ark-web';
import { twMerge } from 'tailwind-merge';

import type { ValuePropItem } from 'src/utils/valueProps';

interface ValuePropsProps {
  valueProps: Record<string, ValuePropItem>;
  className?: string;
}

export const ValueProps = ({ valueProps, className }: ValuePropsProps) => {
  return (
    <ul
      className={twMerge(
        'grid grid-cols-1 justify-center gap-x-40 gap-y-16 lm:grid-cols-[minmax(0,max-content)_minmax(0,max-content)]',
        className
      )}
    >
      {Object.values(valueProps).map((vp) => (
        <li key={vp.id} className="flex items-start  gap-8">
          <Checkmark size={24} className="-mt-4 shrink-0" />
          <Typography variant="body-sm" className="m-0">
            {vp.title}
            {'badge' in vp && (
              <Tag variant="themed-filled" className="ml-8 inline">
                {vp.badge}
              </Tag>
            )}
          </Typography>
        </li>
      ))}
    </ul>
  );
};
